/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useCallback, useEffect } from "react";
import { apiClient } from "../../apiCall";
import { useStore } from "../../../store/useStore";
import Loader from "../common/Loader";

export default function ImportDestinationImages(props) {
	const { state, dispatch } = useStore();
	const apiCall = apiClient(state, dispatch);
	
	const destinations = state.destinations.items || [];
	const [files, setFiles] = useState([]);
	const [loading, setLoading] = useState(false);
	const [processing, setProcessing] = useState(false);
	const [results, setResults] = useState({ successful: [], failed: [] });
	const [error, setError] = useState(null);
	
	// Handle file selection
	const handleFileSelect = (event) => {
		const selectedFiles = Array.from(event.target.files);
		// Filter to only include image files
		const imageFiles = selectedFiles.filter(file => 
			/\.(jpg|jpeg|png|gif|bmp)$/i.test(file.name)
		);
		setFiles(imageFiles);
	};
	
	// Process matching and uploading
	const processImagesForDestinations = async () => {
		setProcessing(true);
		const successful = [];
		const failed = [];
		
		for (const file of files) {
			// Extract kohde_numero from filename (remove extension)
			const fileNameWithoutExt = file.name.split('.').slice(0, -1).join('.');
			
			// Find matching destination
			const matchingDestination = destinations.find(
				dest => dest.kohde_numero && dest.kohde_numero.toString() === fileNameWithoutExt
			);
			
			if (matchingDestination) {
				try {
					// Upload the file
					// const formData = new FormData();
					// formData.append('file', file);
					
					const uploadResponse = await apiCall.UPLOAD('files', file, true);
					console.log('Upload response:', uploadResponse);

					const thumb_id = uploadResponse?.data?.data?.id ?? null;
					
					if (thumb_id) {
						// Update destination with new thumb_id
						const updateResponse = await apiCall.EDIT(
							`destinations`,
							matchingDestination.id,
							{ thumb_id: thumb_id },
							null,
							true
						);

						if (updateResponse.status === 200) {
							successful.push({
								destination:
									matchingDestination.name || matchingDestination.kohde_numero,
								file: file.name,
								fileId: thumb_id,
							});
						} else {
							failed.push({
								destination:
									matchingDestination.name || matchingDestination.kohde_numero,
								file: file.name,
								error: "Failed to update destination",
							});
						}
					}
				} catch (err) {
					failed.push({
						destination: matchingDestination.name || matchingDestination.kohde_numero,
						file: file.name,
						error: err.message
					});
				}
			} else {
				failed.push({
					file: file.name,
					error: 'No matching destination found'
				});
			}
		}
		
		setResults({ successful, failed });
		setProcessing(false);
		apiCall.GET("destinations");
	};
	
	// Initialize data on component mount
	useEffect(() => {
		setLoading(state.destinations.loading);
	}, [state.destinations]);

	return (
		<div className="addnew">
			<h2>Import Destination Images</h2>
			
			{(loading || processing) && <Loader />}
			
			{error && (
				<div className="alert alert-danger">{error}</div>
			)}
			
			<div className="row mb-4">
				<div className="col-md-6">
					<div className="card">
						<div className="card-header">
							Destinations Loaded: {destinations.length}
						</div>
					</div>
				</div>
				<div className="col-md-6">
					<div className="card">
						<div className="card-header">
							Image Files Selected: {files.length}
						</div>
						<div className="card-body">
							<input 
								type="file" 
								multiple 
								accept="image/*"
								onChange={handleFileSelect}
								className="form-control"
							/>
						</div>
					</div>
				</div>
			</div>
			
			{!loading && !processing && (
				<button 
					className="btn btn-primary" 
					disabled={!destinations.length || !files.length}
					onClick={processImagesForDestinations}
				>
					Process Images
				</button>
			)}
			
			{/* Display Results */}
			{results.successful.length > 0 && (
				<div className="card mt-4">
					<div className="card-header bg-success text-white">
						Successfully Processed: {results.successful.length}
					</div>
					<div className="card-body">
						<ul className="list-group">
							{results.successful.map((item, index) => (
								<li key={index} className="list-group-item">
									✅ {item.destination} - File: {item.file} - ID: {item.fileId}
								</li>
							))}
						</ul>
					</div>
				</div>
			)}
			
			{results.failed.length > 0 && (
				<div className="card mt-4">
					<div className="card-header bg-danger text-white">
						Failed: {results.failed.length}
					</div>
					<div className="card-body">
						<ul className="list-group">
							{results.failed.map((item, index) => (
								<li key={index} className="list-group-item">
									 ❌ File: {item.file} - {item.destination ? `Destination: ${item.destination}` : ''} - Error: {item.error}
								</li>
							))}
						</ul>
					</div>
				</div>
			)}
		</div>
	);
}
